import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './volumeCapsuleChartPreview.png';
import valuesPreview from './volumeCapsuleValuesPreview.png';

export const volumeCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Volume capsule compares today&apos;s actual market volume to
                historical market average, while also showing today&apos;s
                predicted remaining volume.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Front',
            src: chartPreview,
            altText: 'volume-capsule-chart-preview',
        },
        {
            title: 'Back',
            src: valuesPreview,
            altText: 'volume-capsule-values-preview',
        },
    ],
};
